import { NavItemType } from "types";

import { getWorkingNav } from "./getWorkingNav";

export const getNavMenuItems = (accessId: string): { items: NavItemType[] } => {
  const items = [getWorkingNav(accessId)];
  return { items };
};
